/**
 * Animation helper - enables animation calculations to be a function of time for consistency across all uses and browsers
 */
const easing = (t: number): number => --t * t * t + 1;
export default easing;
